import { useState } from 'react';

export default function TestimonialSection() {
  const testimonials = [
    {
      quote: "Using Litbuy Spreadsheet completely transformed how I manage my online store inventory. The templates are intuitive, well-organized, and saved me hours every week on data entry and tracking.",
      author: "Sarah Mitchell",
      role: "E-Commerce Store Owner",
      highlight: "Saved 15+ Hours Weekly",
      image: 'https://readdy.ai/api/search-image?query=Professional%20woman%20in%20her%20thirties%20working%20happily%20on%20a%20laptop%20at%20a%20bright%20modern%20coworking%20space%2C%20genuine%20smile%2C%20natural%20daylight%2C%20plants%20in%20background%2C%20authentic%20lifestyle%20portrait%20photography&width=800&height=1000&seq=testimonial-v3-sarah&orientation=portrait',
    },
    {
      quote: "I was struggling with messy spreadsheets until I discovered Litbuy. The pre-built templates for product tracking and sales analytics are exactly what a growing online business needs. Highly recommend for any serious seller.",
      author: "James Rodriguez",
      role: "Online Retail Entrepreneur",
      highlight: "Boosted Sales by 40%",
      image: 'https://readdy.ai/api/search-image?query=Confident%20man%20in%20casual%20business%20attire%20reviewing%20documents%20at%20a%20trendy%20cafe%20with%20exposed%20brick%20wall%2C%20warm%20coffee%20shop%20atmosphere%2C%20focused%20expression%2C%20entrepreneur%20lifestyle%20photography&width=800&height=1000&seq=testimonial-v3-james&orientation=portrait',
    },
    {
      quote: "The category organization and clean layout make it so easy to keep track of inventory across multiple product lines. Litbuy Spreadsheet is hands down the best tool I have used for e-commerce management.",
      author: "Emily Chen",
      role: "Multi-Store Manager",
      highlight: "Streamlined 3 Stores",
      image: 'https://readdy.ai/api/search-image?query=Asian%20female%20entrepreneur%20standing%20in%20a%20bright%20minimal%20home%20office%20with%20organized%20shelves%20of%20products%20behind%20her%2C%20arms%20crossed%20with%20satisfied%20expression%2C%20clean%20modern%20aesthetic%2C%20professional%20portrait&width=800&height=1000&seq=testimonial-v3-emily&orientation=portrait',
    },
  ];

  const [current, setCurrent] = useState(0);

  const next = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const prev = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  const t = testimonials[current];

  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-10 md:gap-16">
        <div className="lg:w-2/5">
          <div className="rounded-2xl overflow-hidden aspect-[4/5]">
            <img
              src={t.image}
              alt={'Litbuy Spreadsheet testimonial - ' + t.author}
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="lg:w-3/5 flex flex-col justify-center">
          <span className="text-xs md:text-sm font-medium text-foreground-500 tracking-wider uppercase">(Seller Success)</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
            Boosted Traffic
            <br />
            <span className="text-foreground-400">By 300%</span>
          </h2>

          <div className="mt-8 md:mt-10">
            <div className="relative">
              <i className="ri-double-quotes-l text-3xl md:text-4xl text-primary-200 absolute -top-2 -left-1"></i>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed pl-8 md:pl-10">
                {t.quote}
              </p>
            </div>
            <div className="mt-6 md:mt-8">
              <p className="text-sm md:text-base font-semibold text-foreground-900">&mdash; {t.author}</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">{t.role}</p>
              <span className="inline-block mt-3 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                {t.highlight}
              </span>
            </div>
          </div>

          <div className="flex items-center gap-3 mt-8 md:mt-10">
            <button
              onClick={prev}
              className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-400 hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={next}
              className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
            <span className="text-xs md:text-sm text-foreground-400 ml-2">
              {current + 1} / {testimonials.length}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}